/**
 * Source-backed railway presentation.
 *
 * GRPK supplies one line per physical track. These dimensions describe the
 * visible track assembly around that centreline. Separately mapped OSM tags
 * may select gauge/catenary and exact equipment points, but they do not add
 * routes, platforms, collision, timetables, or train simulation.
 */
export const RAILWAY_RENDER_CONFIG = Object.freeze({
  ballastShoulderWidthM: 3.85,
  ballastShoulderLiftM: 0.025,
  ballastWidthM: 3.25,
  railGaugeM: 1.52,
  railHeadWidthM: 0.105,
  railHeadHeightM: 0.12,
  sleeperLengthM: 2.65,
  sleeperWidthM: 0.24,
  sleeperSpacingM: 0.68,
  ballastLiftM: 0.045,
  sleeperLiftM: 0.09,
  railLiftM: 0.21,
  maximumSegmentLengthM: 8,
  distantBedWidthM: 2.7,
  distantLiftM: 0.055,
  catenaryContactHeightM: 5.75,
  catenaryMessengerHeightM: 6.55,
  catenaryWireWidthM: 0.045,
  catenaryDropperSpacingM: 12,
  catenaryMastSpacingM: 48,
  catenaryMastOffsetM: 2.45,
  catenaryMastHeightM: 7.15,
  catenaryMastWidthM: 0.14,
  equipmentLiftM: 0.07,
});
